// ##############################
// // // LoginPage view styles
// #############################

import {
  container,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";

import bgMoebel from "assets/img/bg-moebel.jpg";
import bgStardust from "assets/img/bg-stardust.png";

function bg(){
  return window.location.search.indexOf('v=2') > 0 ? bgMoebel : bgStardust
}

const loginPageStyle = {
  container: {
    ...container,
    ...cardTitle,
    color: "#FFFFFF",
    paddingTop: '18vh'
  },
  cardTitle: {
    ...cardTitle,
    color: "#FFFFFF"
  },
  textCenter: {
    textAlign: "center"
  },
  content: {
    minHeight: "calc(100vh)",
    position: "relative",
    zIndex: "4",
    backgroundColor: "#000000",
    backgroundImage: "url("+bg()+")"
  },
  animationClass: {
    animation: "scrollBad 60s linear infinite"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  }
};

export default loginPageStyle;
